import { useState, useRef } from "react";
import { motion, AnimatePresence } from "motion/react";
import LearnLogo from "@assets/icons/LearnLogo.svg";
import MetaLogo from "@assets/icons/MetaLogo.svg";
import user from "@assets/icons/user.svg";
import chevronDown from "@assets/icons/chevron.svg";
import logoutIcon from "@assets/icons/logout-icon.svg";
import styles from "./Header.module.css";
import { useNavigate } from "react-router-dom";
import { useClickOutside } from "@hooks/useClickOutside";
import { VERTICAL_TYPES } from "@constants/verticalConstants";
import { useBrandingConfig, useVertical } from "@hooks/store";

const HEADER_LOGOS = {
  [VERTICAL_TYPES.LEARN]: LearnLogo,
  [VERTICAL_TYPES.META]: MetaLogo,
} as const;

function Header() {
  const vertical = useVertical();
  const branding = useBrandingConfig();
  const logoSrc = HEADER_LOGOS[vertical] ?? LearnLogo;
  const navigate = useNavigate();
  const [logoutOpen, setLogoutOpen] = useState(false);
  const userMenuRef = useRef<HTMLDivElement>(null);
  const isLoggedIn = localStorage.getItem("accessToken") ? true : false;
  const path = location.pathname;

  const handleLogOut = () => {
    localStorage.clear();
    navigate("/");
  };
  const handleIconClick = () => {
    navigate("/dashboard");
  };

  useClickOutside(userMenuRef, () => setLogoutOpen(false), logoutOpen);

  return (
    <header className={styles.header}>
      <img
        src={logoSrc}
        alt={branding.portalTitle}
        className={styles.logo}
        onClick={handleIconClick}
      />
      {isLoggedIn && path != "/" && (
        <div className={styles.controls}>
          <div className={styles.userMenu} ref={userMenuRef}>
            <div
              className={styles.userProfile}
              onClick={() => setLogoutOpen(!logoutOpen)}
            >
              <img src={user} alt="User Profile" className={styles.userIcon} />
              <img
                src={chevronDown}
                alt="Arrow Down"
                className={`${styles.chevronDown} ${
                  logoutOpen ? styles.rotate : ""
                }`}
              />
            </div>
            <AnimatePresence>
              {logoutOpen && (
                <motion.div
                  className={styles.logout}
                  onClick={handleLogOut}
                  initial={{ opacity: 0, scale: 0.8, y: -10 }}
                  animate={{ opacity: 1, scale: 1, y: 0 }}
                  exit={{ opacity: 0, scale: 0.8, y: -10 }}
                  transition={{
                    type: "spring",
                    stiffness: 300,
                    damping: 25,
                  }}
                >
                  <img src={logoutIcon} alt="Logout" className={styles.icon} />
                  <span>Logout</span>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
